import { ProductCodes, Product } from '../../../../../types/products';
import { PromotionCode } from '../../../../../types/items';

export const convertProductCodeToPromoCodeProperty = (productCode: ProductCodes): keyof PromotionCode | null => {
  switch (productCode) {
    case ProductCodes.PayAsYouGo:
      return null;
    case ProductCodes.ProYear12videos:
      return 'price_pro_12';
    case ProductCodes.ProYear24videos:
      return 'price_pro_24';
    case ProductCodes.TeleprompterAnnual:
      return 'price_teleprompter_annual';
    case ProductCodes.TeleprompterMonthly:
      return 'price_teleprompter_monthly';
    default:
      return null;
  }
};

export const getPriceWithDiscount = (productCode: ProductCodes, promoCode: PromotionCode, fullPrice: number): number => {
  const propertyWithPrice = convertProductCodeToPromoCodeProperty(productCode);

  if (propertyWithPrice && promoCode[propertyWithPrice]) {

    const priceWithDiscount = promoCode[propertyWithPrice] as number;

    return priceWithDiscount >= fullPrice ? fullPrice : priceWithDiscount;
  }

  return fullPrice;
};

export const getDurationPromoCodeLabel = (promoCode: PromotionCode | null, subscription: Product): string => {
  const billingPeriod = subscription?.billing_period_count || 1;
  const promoCodeMonths = (promoCode && promoCode.duration_periods) ? promoCode.duration_periods : 0;
  const isYearSubPeriod = (Number.isInteger(billingPeriod / 12)) ? billingPeriod / 12 : 0;
  const divider = isYearSubPeriod || 1;
  const fullPrice = subscription?.cost_per_unit || 0;
  let onePeriodPrice: number = subscription
    ? parseFloat((fullPrice / divider).toFixed(2))
    : 0;
  onePeriodPrice = Number.isInteger(onePeriodPrice) ? Math.round(onePeriodPrice) : onePeriodPrice;
  const periodLabel = isYearSubPeriod ? 'year' : 'month';

  return promoCodeMonths ? (
    `$${onePeriodPrice}/${periodLabel} after promo code period 
              (${promoCodeMonths} month${(promoCodeMonths === 1) ? '' : 's'})`
  ) : 'The discount does not expire';
};
